import { memo } from 'react';

import { IconAttributeJourney } from '@components/icons/attribute-journey';

import { ACTION_TYPES, getActionLabel } from 'ui/actions/action-config';
import { NodeActions } from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

const ACTION_TYPE = ACTION_TYPES.update_fields;

export const Node = memo((node: JourneyNode<typeof ACTION_TYPE>) => {
  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard
        node={node}
        icon={<IconAttributeJourney color="elementPurpleInvert" />}
        label={getActionLabel(ACTION_TYPE)}
      >
        <NodeActions node={node} />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
});
